<mat-nav-list>
    <app-sidebar-list-item *ngFor="let item of navItems" [item]="item"></app-sidebar-list-item>
    <div class="menu-meta">
        <p class="version-info">Suarato's Quickreport | version {{getVersion()}}</p>
    </div>
</mat-nav-list>